import styled from 'styled-components';
export const ConversationProcessingContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-self: stretch;
  padding: 0 ${({ theme }) => theme.spacing.md}px;
  width: 100%;
  box-sizing: border-box;
`;
export const ConversationProcessingContent = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  flex-wrap: wrap;
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  background: ${({ theme }) => theme.colors.green_4};
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.green_3};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
`;
export const ConversationProcessingBadge = styled.span `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => `${theme.spacing.sm}px`};
  border-radius: ${({ theme }) => theme.border_radius.full};
  background: ${({ theme }) => theme.colors.green_status};
`;
export const ConversationProcessingBadgeSpinner = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
